import React, { useEffect, useState } from "react";
import Tour from "src/components/Tour";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import { userDontShowDialogsSelector } from "src/store/system/selector";
import DontShowThisMessageAgainCheckbox from "src/components/DontShowThisMessageAgainCheckbox";

const Key = "walk_through_pending_inventory_import";

const Steps = [
  {
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory Import - 1/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            These listings did not match anything in your inventory. Review
            them, fill in any missing details, and add the ones you want to
            keep.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(1)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#pending-inventory-import-grid",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory Import - 2/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            SKU, purchase price, purchase date, brand, location, and vendor can
            be edited directly in the grid. A purchase date is required before
            an item can be added.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(0)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(2)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#inventory-import-actions",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory Import - 3/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select the listings you want to import, then click “Add”. “Delete
            Selected” removes listings you do not want to keep.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(3)}
          >
            Next
          </Button>
        </DialogActions>
      </>
    ),
  },
  {
    selector: "#inventory-import-actions",
    content: (props) => (
      <>
        <DialogTitle>Pending Inventory Import - 4/4</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Added items become inventory immediately. You can always find the
            rest here on the next sync.
          </DialogContentText>
          <DontShowThisMessageAgainCheckbox dialog={Key} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.goTo(2)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.close()}
          >
            Close
          </Button>
        </DialogActions>
      </>
    ),
  },
];

const useStyles = makeStyles((theme) => ({
  helper: {
    maxWidth: "80%",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "500px",
    },
    padding: 0,
  },
}));

export function PendingInventoryImportWalkThrough() {
  const [open, setOpen] = useState(true);
  const userDontShowDialogs = useSelector(userDontShowDialogsSelector);
  const classes = useStyles();
  const isOpen =
    open && userDontShowDialogs && !userDontShowDialogs?.includes(Key);

  return (
    <Tour
      startAt={0}
      closeWithMask={false}
      disableFocusLock
      steps={Steps}
      isOpen={isOpen}
      onRequestClose={() => {
        setOpen(false);
      }}
      showButtons={false}
      showCloseButton={false}
      showNavigation={false}
      showNavigationNumber={false}
      showNumber={false}
      disableDotsNavigation
      rounded={12}
      className={classes.helper}
      disableInteraction
    />
  );
}

export default function PendingInventoryImportWalkThroughGate({
  loading,
}: {
  loading: boolean;
}) {
  const [render, setRender] = useState(!loading);
  useEffect(() => {
    if (loading) return;
    const timer = setTimeout(() => setRender(true));
    return () => clearTimeout(timer);
  }, [loading]);
  if (!render) return null;
  return <PendingInventoryImportWalkThrough />;
}
